import * as React from 'react';

// VORTEX (VIVOTEK) integration card logo — stylised vortex/aperture mark on a
// rounded tile matching the App logo frame.
const LogoVortexApp = (props) => (
	<svg xmlns='http://www.w3.org/2000/svg' width='110' height='110' viewBox='0 0 110 110' fill='none' {...props}>
		<rect width='110' height='110' rx='24' fill='#0186D1' />
		<g stroke='white' strokeWidth='5' strokeLinecap='round' fill='none'>
			<path d='M55 23 A32 32 0 0 1 87 55' />
			<path d='M87 55 A32 32 0 0 1 55 87' opacity='0.75' />
			<path d='M55 87 A32 32 0 0 1 23 55' opacity='0.5' />
			<path d='M23 55 A32 32 0 0 1 55 23' opacity='0.25' />
		</g>
		<circle cx='55' cy='55' r='12' fill='white' />
		<circle cx='55' cy='55' r='5' fill='#0186D1' />
	</svg>
);

export default LogoVortexApp;
